module.exports = __webpack_public_path__ + "media/svg-new/icon-settings-ee457f27.svg";